import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'A nosa escolla',
  bestPriceBadge: 'Mellor prezo',
  regulatedNotice: {
    prescriptionOnly: 'Só con receita',
    professionalUse: 'Uso profesional',
    fromVeterinarian: 'Dispoñible a través do seu veterinario',
    fromPharmacist: 'Dispoñible a través dun farmacéutico',
    noOnlinePurchase: 'Non se vende en liña',
    professionalSupply: 'Véndese a través de provedores profesionais',
    whyNoLink: 'Analizamos este produto, pero non enlazamos con el.',
  },
};
